module.exports = function getResource(label, vars = []) {
    let resources = {
        main: 'Happening at Sephora',
        myReservations: 'My Reservations',
        findASephora: 'Find a Sephora',
        happeningAtSephoraNavigation: 'Happening at Sephora Navigation',
        beautyServicesFaq: 'Beauty Services FAQ',
        makeupServices: 'Makeup Services'
    };
    return resources[label];
};
